<template lang="html">

  <header class="header" :show="showmenu">
    <div class="container row-between">

      <router-link to="/">
        <img class="logo" src="/static/img/logo-fundacion-gris.svg" alt="Logo de la fundación">
      </router-link>

      <div class="row-end menu">
        <router-link class="not-active-link inicio" to="/">Inicio</router-link>
        <div class="container-submenu">
          <router-link @mouseenter.native="setSubmenu('fundacion')" :to="$t('enlaces.fundacion')">La Fundación</router-link>  
          <div class="submenu" :show="submenus.fundacion" @mouseleave="clearsubmenu">
            <router-link :to="$t('enlaces.mision')">Misión</router-link>
            <router-link :to="$t('enlaces.fundadores')">Fundadores y Miembros</router-link>
            <router-link :to="$t('enlaces.transparencia')">Transparencia</router-link>
            <router-link :to="$t('enlaces.planesactuacion')">Planes de actuación</router-link>
          </div>
        </div>
        <div class="container-submenu">
          <a @mouseenter="setSubmenu('agua')">Agua para todos</a>
          <div class="submenu" :show="submenus.agua" @mouseleave="clearsubmenu">
            <router-link class="not-active-link" :to="$t('enlaces.aguaparatodos')">El proyecto</router-link>
            <router-link :to="$t('enlaces.proyectosencurso')">Proyectos en curso</router-link>
            <router-link :to="$t('enlaces.proyectosfinalizados')">Proyectos conseguidos</router-link>
          </div>
        </div>

        <!-- <router-link :to="$t('enlaces.civsem')">CIVSEM</router-link> -->

        <div class="container-submenu">
          <router-link :to="$t('enlaces.emprendimiento')" @mouseenter.native="setSubmenu('emprendimiento')">Emprendimiento</router-link>
          <div class="submenu" :show="submenus.emprendimiento" @mouseleave="clearsubmenu">
            <router-link class="not-active-link" :to="$t('enlaces.emprendimiento')">El proyecto</router-link>
            <router-link  :to="$t('enlaces.mide')">Mide</router-link>
            <router-link  :to="$t('enlaces.patio')">Patio Campus</router-link>
          </div>
        </div>
        <!-- <router-link :to="$t('enlaces.noticias')">Noticias</router-link> -->
        <router-link :to="$t('enlaces.contacto')">Contacto</router-link>

        <router-link :to="$t('enlaces.colabora')" class="colabora column-center">
          <i class="fa fa-heart"></i>
          Colabora
        </router-link>


      </div>


      <router-link :to="$t('enlaces.colabora')" class="colabora column-center">
        <i class="fa fa-heart"></i>
        Colabora
      </router-link>


      <a class="show-menu" @click="showmenu = true">
        <span></span>
        <span></span>
        <span></span>
      </a>

      <a @click="showmenu = false" class="close">✕</a>
      
    </div>
  </header>

</template>

<script lang="js">
  export default  {
    name: 'app-header',
    data(){
      return{
        submenus : {
          fundacion : false,
          agua : false,
          emprendimiento : false
        },
        showmenu : false
      }
    },
    methods : {
      setSubmenu(el){
        this.clearsubmenu();
        this.submenus[el] = true;
      },
      clearsubmenu(){
        Object.keys(this.submenus).forEach(e => {
          this.submenus[e] = false;
        });
      }
    },
    watch : {
      '$route'(){
        this.clearsubmenu();
        this.showmenu = false;
      }
    },
}
</script>




// WEBPACK FOOTER //
// src/components/parts/header.vue